import { createEntityState, GenericEntityStateClass } from '../../core/state/entity.state';
import { Injectable } from '@angular/core';
import { EntityService } from '../../core/services/entity.service';
import { GlobalMetaDataTypeEntity } from '../global-metadata-type.entity';

export const STATE_NAME = 'globalMetaDataTypeEntity';

export const GlobalMetaDataTypeEntityState: GenericEntityStateClass<GlobalMetaDataTypeEntity> =
  createEntityState<GlobalMetaDataTypeEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class GlobalMetaDataTypeEntityService extends EntityService<GlobalMetaDataTypeEntity> {
  constructor() {
    super();
    this.resourceType = 'global-metadata-types';
    this.stateClass = GlobalMetaDataTypeEntityState;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    const stateClass = this.stateClass;
    const sliceName = STATE_NAME;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (storeState: any): GlobalMetaDataTypeEntity[] => {
      const slice = storeState[sliceName];
      return stateClass.allByQuery(slice, { query });
    };
  }
}
